export const ADD_IDENTITY_ROLE_DRAWER = 'ADD_IDENTITY_ROLE_DRAWER';
export const IDENTITY_ROLE_DETAILS_TAB_KEY = 'roleDetails';
export const IDENTITY_ROLE_ACCESS_GRANT_TAB_KEY = 'accessGrant';
export const IDENTITY_ROLE_ASSIGN_USERS_TAB_KEY = 'assignUsers';
export const IDENTITY_ROLE_DETAILS_STEP = 0;
export const IDENTITY_ROLE_ACCESS_GRANT_STEP = 1;
export const IDENTITY_ROLE_ASSIGN_USERS_STEP = 2;
export const IDENTITY_ROLE_SUCCESS_SCREEN_STEP = 3;
export const IDENTITY_ACTIONS_CUSTOM_PADDING_RIGHT = '33px';
